export default __webpack_public_path__ + "../images/category-catalog-1.png";